module.exports = __webpack_public_path__ + "img/KaohsiungTaiUrbanResort.b4c92ef5.jpg";